export default {
    // Remember the currentStep
    currentStep() {
        if(isNaN(this.currentStep)) {
            this.currentStep = 1;
        }
    }
}
